// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Realtime_wrapper__1cKab"};